export default __webpack_public_path__ + "static/mapbox-bf9e0b1fe6269d28fd29e6efbc4f37b7.png";